<template>
    <div class="productList" ref="targetElement" v-if="currentShow">
        <div class="sortBox" v-if="productType != 'clinic'">
            <div class="sortCount">{{ totalText }}</div>
            <div class="sort">
                <select name="courseSort" class="sortSelect" @change="onChangeSort" v-model="currentSortSelect">
                    <option :value="item.value" v-for="item in sortList">{{ item.name }}</option>
                </select>
            </div>
        </div>
        <div class="spinner-border text-primary" role="status" v-if="isLoading">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="productItems" :class="productType" v-if="!isLoading">

            <component
                v-for="item in items" :key="item.id"
                :is="getComponentType"
                v-bind="getComponentProps(productType, item)"
            ></component>

            <div class="empty-text" v-if="total == 0">搜尋不到 {{ productTypeMap[productType] }}</div>
        </div>
        <div class="pagination">
            <span @click="setPage(1)"
                  :class="{active: currentPage === 1, disabled: isLoading}">1</span>
            <span v-if="currentPage > 3"
                  :class="{disabled: isLoading}">...</span>

            <span v-for="(page,key) in surroundingPages"
                  @click="setPage(page)"
                  :key="key"
                  :class="{active: currentPage === page, disabled: isLoading}">{{ page }}</span>

            <span v-if="currentPage < lastPage - 3"
                  :class="{disabled: isLoading}">...</span>
            <span @click="setPage(lastPage)" v-if="lastPage > 1"
                  :class="{active: currentPage === lastPage, disabled: isLoading}">
                {{ lastPage }}</span>
        </div>
    </div>
</template>
<script>

import Datalayer from 'Controllers/Web/Datalayer';
import ProductComponent from 'Vue/Web/Shop/Product/ProductComponent.vue';
import CourseComponent from 'Vue/Web/Shop/Course/CourseComponent.vue';
import LongNoteComponent from 'Vue/Web/Common/Note/LongNoteComponent.vue';
import ClinicListComponent from 'Vue/Web/Common/Clinic/ClinicListComponent.vue';

export default {
    name: 'ItemList',
    components: {
        ProductComponent,
        CourseComponent,
        LongNoteComponent,
        ClinicListComponent,
    },
    props: {
        show: {
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: true,
        },
        url: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: '/api/getProductByListSearch',
        },
        productType: {
            type: String,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: 'product',
        },
    },
    data() {
        return {
            currentShow: false,
            isLoading: true,
            items: [],
            total: 0,
            currentPage: 1,
            lastPage: 1,
            links: [],
            currentFilterSelect: '',
            currentSortSelect: '',
            currentKeywordSelect: '',
            currentClassMetaIdSelect: '',
            filterList: [
                {
                    name: '全部產品',
                    value: '',
                },
                {
                    name: '我的標記',
                    value: 'mark',
                    icon: './img/pic/prompt.svg',
                    authCheck: true,
                },
            ],
            sortList: [
                {
                    name: '預設排序',
                    value: '',
                },
                {
                    name: '最新上架',
                    value: 'new',
                },
                {
                    name: '熱賣',
                    value: 'hot',
                },
                {
                    name: '價格高到低',
                    value: 'priceDesc',
                },
                {
                    name: '價格低到高',
                    value: 'priceAsc',
                },
            ],
            productTypeMap: {
                product: '產品',
                course: '課程',
                note: '文章',
                clinic: '疼痛醫療所',
            },
        };
    },
    computed: {
        totalText() {
            const productTypeText = this.productTypeMap[this.productType] || '產品';

            return `共有 ${this.total} 個${productTypeText}`;
        },
        surroundingPages() {
            const pages = [];
            const start = Math.max(2, this.currentPage - 2);
            const end = Math.min(this.lastPage - 1, this.currentPage + 2);

            // eslint-disable-next-line no-plusplus
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            return pages;
        },
        getComponentType() {
            const componentMap = {
                product: 'product-component',
                course: 'course-component',
                note: 'long-note-component',
                clinic: 'clinic-list-component',
            };
            return componentMap[this.productType] || null;
        },
    },
    beforeMount() {
        this.currentShow = !!this.show;
        if (this.productType === 'note') {
            this.sortList = [
                {
                    name: '預設排序',
                    value: '',
                },
                {
                    name: '最新上架',
                    value: 'new',
                },
                {
                    name: '熱門文章',
                    value: 'hot',
                },
            ];
        }
    },
    mounted() {
        this.setUrlKeyWord();
        this.setupIntersectionObserver();
    },
    methods: {
        getComponentProps(productType, item) {
            switch (productType) {
                case 'product':
                    return {
                        pageType: 'list',
                        name: item.name,
                        productId: item.id,
                        slug: item.slug,
                        picUrl: item?.Pics[0]?.url?.w0h0,
                        minPrice: item.minPrice,
                        favoriteAdded: !!item.favoriteAdded,
                        sku: item.productNumber,
                        category: item.textClassMetas,
                        preorderActive: !!item.ProductField?.preorderActive,
                        preorderToDate: item.ProductField?.preorderToDate,
                        preorderFromDate: item.ProductField?.preorderFromDate,
                        typeIdSpecIdKey: item.typeIdSpecIdKey,
                        rating: item.ratingsAvgRating,
                        ratingCount: item.ratingsCount,
                    };
                    break;
                case 'course':
                    return {
                        course: item,
                        courseLink: `course/${item.slug}`,
                        picUrl: item?.Pics[0]?.url?.w0h0,
                        specStatus: item?.specStatus,
                        favoriteAdded: !!item.favoriteAdded,
                        addFavoriteUrl: `course/favorite/${item.id}`,
                        isFree: item.isFree,
                        minPrice: item.minPrice,
                        maxPrice: item.maxPrice,
                        wishOrderActive: item.CourseField?.wishOrderActive,
                        targetSalesCount: item.CourseField?.wishOrderActive
                            ? item.CourseField.wishOrderReachSales
                            : item.targetSalesTime,
                        currentSalesCount: item.CourseField?.wishOrderActive
                            ? item.wish_order_user_count + item.CourseField.wishOrderBaseSalesCount
                            : item.salesTime + item.baseSalesTime,
                        limitedSalesStartDate: item.CourseField?.wishOrderActive
                            ? item.CourseField.wishOrderFromDate
                            : item.crowdfundingStartAt,
                        limitedSalesEndDate: item.CourseField?.wishOrderActive
                            ? item.CourseField.wishOrderToDate
                            : item.crowdfundingEndAt,
                        typeIdSpecIdKey: item.typeIdSpecIdKey,
                        rating: item.ratingsAvgRating,
                        ratingCount: item.ratingsCount,
                    };
                    break;
                case 'note':
                    return {
                        note: item,
                        noteId: item.id,
                        title: item.title,
                        description: item.description,
                        picUrl: item.picUrl,
                        postAt: item.postAt,
                        slug: item.slug,
                        favoriteAdded: !!item.favoriteAdded,
                        pageName: 'lecturerView',
                        pagePosition: 'hotArticle',
                        typeIdSpecIdKey: item.typeIdSpecIdKey,
                    };
                    break;
                case 'clinic':
                    return { item };
                    break;
                default:
                    return {};
            }
        },
        setPage(page) {
            if (this.currentPage === page || this.isLoading) {
                return;
            }
            const pageLink = this.links.find((link) => link.label == page);
            if (pageLink && pageLink.url) {
                window.location.href = pageLink.url;
            }
        },
        setUrlKeyWord() {
            const url = new URL(window.location.href);
            this.currentSortSelect = url.searchParams.get('sort') ?? '';
            this.currentFilterSelect = url.searchParams.get('filter') ?? '';
            this.currentKeywordSelect = url.searchParams.get('keyword') ?? '';
            this.currentClassMetaIdSelect = url.searchParams.get('classMetaId') ?? '';
        },
        onChangeSort() {
            const url = new URL(window.location.href);

            if (this.currentSortSelect) {
                url.searchParams.set('sort', this.currentSortSelect);
            } else {
                url.searchParams.delete('sort');
            }

            if (this.currentFilterSelect) {
                url.searchParams.set('filter', this.currentFilterSelect);
            } else {
                url.searchParams.delete('filter');
            }

            if (this.currentKeywordSelect) {
                url.searchParams.set('keyword', this.currentKeywordSelect);
            } else {
                url.searchParams.delete('keyword');
            }

            if (this.currentClassMetaIdSelect) {
                url.searchParams.set('classMetaId', this.currentClassMetaIdSelect);
            } else {
                url.searchParams.delete('classMetaId');
            }

            window.location.href = url.href;
        },
        setupIntersectionObserver() {
            const options = {
                root: null, // 代表 viewport
                threshold: 0.2, // 當元素進入到 10% 的範圍時觸發
            };
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && this.currentShow) {
                        this.getResult();
                        observer.unobserve(this.$refs.targetElement); // 只觸發一次，然後停止觀察
                    }
                });
            }, options);
            if (this.$refs.targetElement) {
                observer.observe(this.$refs.targetElement);
            }
        },
        formatDate(dateString) {
            const options = {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
            };
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', options);
        },
        async getResult() {
            let response;
            const baseUrl = window.location.origin;
            const url = new URL(window.location.href);

            const params = new URLSearchParams(url.search); // 獲取當前 URL 的參數

            const targetUrl = new URL(this.url, baseUrl);
            // 合併當前 URL 的參數到目標 URL
            params.forEach((value, key) => {
                targetUrl.searchParams.append(key, value);
            });
            try {
                response = await axios.get(targetUrl.toString());
                this.items = response.data.data;
                this.total = response.data.total;
                this.currentPage = response.data.current_page;
                this.lastPage = response.data.last_page;
                this.links = response.data.links;
                this.isLoading = false;
                if (response.data?.datalayer) {
                    Datalayer.push(response.data.datalayer);
                }
                if (this.items?.length > 0) {
                    // 等待 DOM 完全更新後再初始化 OwlCarousel
                    this.$nextTick(() => {
                    });
                } else {
                    // this.currentShow = false;
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>

<style scoped lang="scss">

$maincolor: #72ca4a;
.spinner-border {
    margin: 50px 50%;
}

.sortBox {
    display: flex;
    justify-content: space-between;
    margin: 0;
}

.disabled {
    pointer-events: none;
    opacity: 0.6; /* 降低透明度，使其看起來像是被禁用的 */
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}

.pagination span {
    margin: 0 5px;
    padding: 5px 10px;
    cursor: pointer;
    border: 1px solid #ddd;
}

.pagination {
    span {
        &.active, &:hover {
            background-color: #72ca4a;
            color: white;
        }
    }
}

.relatedTitleBox {
    margin-bottom: 0rem;
}

.more {
    position: relative;
    font-size: 14px;
    color: #555;
    cursor: pointer;

    &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0px;
        width: 50%;
        height: 1px;
        background-color: #999;
    }

    &:hover {
        transition: 0.4s;
        color: #72ca4a;

        &::after {
            width: 100%;
            background: #72ca4a;
            transition: 0.3s linear;
        }
    }
}

.productList {
    width: 100%;
    margin-bottom: 2rem;

    .productItems {
        display: flex;
        flex-wrap: wrap;

        .productItem {
            display: block;
            width: 25%;
            margin: 0 0% 15px;
            overflow: hidden;
            @media (max-width: 768.98px) {
                width: 40%;
                margin: 0 5% 5rem;
            }
            @media (max-width: 479.98px) {
                width: 44%;
                margin: 0 3% 3rem;
            }

            .pic {
                background-color: #eee;
                position: relative;

                img {
                    width: 100%;
                }
            }

            .favoriteBox {
                display: flex;
                justify-content: space-between;
                margin-top: 1rem;

                .favoriteBtn {
                    width: 30px;
                    cursor: pointer;
                    background: none;
                    border: none;

                    &:hover,
                    &.added {
                        img {
                            transition: 0.3s;
                            background: url(../img/pic/love_green.svg) no-repeat;
                            background-size: contain;
                        }
                    }
                }

                .ratingNumber {
                    display: flex;
                    align-items: center;

                    img {
                        width: 18px;
                        margin-right: 6px;
                    }

                    span {
                        color: #999;
                        margin-left: 3px;
                    }
                }
            }

            .name {
                margin-top: 1rem;
                display: block;
                font-size: 14px;
                font-weight: 500;
                color: #333;
            }

            .price {
                display: block;
                color: $maincolor;
                font-size: 16px;
                font-weight: 500;
                margin-top: 0.5rem;
            }
        }

        .empty-text {
            font-size: 20px;
            color: #666;
            margin: 3rem 0;
        }
    }
}

.productItems.course {
    gap: 16px; /* 元素之間的間距，可根據需要調整 */
    margin-top: 1rem;

    .class-item {
        flex: 0 0 calc(50% - 8px); /* 一排兩個，間距平均分配 */
        @media (max-width: 768px) { /* 手機尺寸的響應式設計 */
            flex: 0 0 100%; /* 一排一個 */
        }
    }
}

.productItems.note {
    margin-bottom: 3rem;

    .productItem {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 4% 0%;
        margin: 0;
    }
}

.productItems.clinic {
    display: block;
}
</style>
